<template>
  <el-row style="margin-top: -10px" >
    <el-col>
      <el-row style="margin-bottom: 10px">
        <el-card class="box-card">
          <el-button-group >
            <el-button type="primary" icon="el-icon-refresh" round size="medium" @click="refreshData">刷新数据</el-button>
            <el-button type="danger" icon="el-icon-delete-solid" round size="medium" @click="clearData">清空全部</el-button>
          </el-button-group>
          <el-input
              placeholder="搜索设备编号"
              v-model="pagParams.searchval"
              clearable
              style="height: 30px; width: 200px;margin-left: 10px;margin-right: 10px"
              prefix-icon="el-icon-view">
          </el-input>
          <el-button type="primary" icon="el-icon-search" round size="medium" @click="searchData">搜索</el-button>
        </el-card>
      </el-row>


    </el-col>
    <el-col style="margin-top: -5px">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="this.pagParams.page"
          :page-sizes="[20, 100, 200, 500]"
          :page-size="this.pagParams.limit"
          :total="this.pagParams.total"
          layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-col>
    <el-table
        class="el-ta"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        stripe
        border
        size="mini"
        highlight-current-row
        highlight-selection-row
        :default-sort = "{prop: 'sort', order: 'ascending'}">

      <el-table-column
          type="selection"
          width="40px">
      </el-table-column>

      <!--      <el-table-column-->
      <!--          prop="sort"-->
      <!--          label="序号"-->
      <!--          width="80px"-->
      <!--          sortable-->
      <!--          show-overflow-tooltip>-->
      <!--        <template slot-scope="scope">{{ scope.$index+1 }}</template>-->
      <!--      </el-table-column>-->
      <el-table-column
          prop="machine"
          label="设备"
          width="80px"
          sortable
          show-overflow-tooltip
      >

      </el-table-column>
      <el-table-column
          prop=""
          label="好友数量"
          width="100px"
          sortable
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{friendCount(scope.row)}}
        </template>
      </el-table-column>

      <el-table-column
          prop="data1"
          label="好友列表"
          width="300px"
          sortable
          show-overflow-tooltip
      >

      </el-table-column>

      <el-table-column
          prop="update_time"
          label="最后更新"
          width="150px"
          sortable
          show-overflow-tooltip
          :formatter="timeAgo">

      </el-table-column>
      <el-table-column
          prop="work"
          label="操作">
        <template slot-scope="scope">
          <!--          <el-button icon="el-icon-edit" size="mini" @click="editData(scope.row)">修改</el-button>-->
          <el-button type="success" icon="el-icon-data" size="mini" @click="selectData(scope.row)">详细</el-button>
          <el-button type="warning" icon="el-icon-error" size="mini" @click="delData(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        :visible.sync="show_xx"
        width="400px"
        :title=curDevice
    >

      <el-col>
        <el-button icon="el-icon-document-add" size="mini" @click="copyGroupList()" type="success" style="margin-bottom: 20px" >复制所有</el-button>
<!--        <el-button icon="el-icon-document-add" size="mini" @click="exportExcel()" type="success" style="margin-bottom: 20px" >生成表格</el-button>-->
        <el-button icon="el-icon-document-add" size="mini" @click="post_delFriends()" type="warning" style="margin-bottom: 20px" >重置数据</el-button>
      </el-col>
      <!--      <el-col>-->
      <!--        <el-tag type="info">下载自动生成表格，必须是添加好友时使用自动备注</el-tag>-->
      <!--      </el-col>-->

      <el-input type="textarea" :rows="30" v-model="userList" style="width: 100%"></el-input>

    </el-dialog>


  </el-row>

</template>

<script>


import {trim} from "core-js/internals/string-trim";
import { timeago } from '@/utils/formatTime'
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

export default {

  data() {
    return {
      userName : window.sessionStorage.getItem('account'),
      tableData: [],
      multipleSelection: [],

      pagParams:{
        total:20,limit:20,page:1,searchval:''
      },
      formAdd: {
        lab:'',data:[], status:0,
      },

      rules: {
        lab: [
          { required: true, message: '请填写标识', trigger: 'blur' }
        ]
      },

      file: null,
      tmp:'',
      userList:"",
      curDevice:'',
      show_xx:false,
      intervalId:null,
      allFriendCount:0,
    }
  },
  created() {
    this.getData();
    this.intervalId = setInterval(this.getData, 3000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  methods: {
    timeAgo(val) {
      let v = new Date(val.update_time).getTime();
      return timeago(v);
    },

    selectData(row){
      this.show_xx = true;
      this.curDevice = row.machine;
      this.userList = '';

      if (row.data1){
        // console.log(row);

        let arr;
        let json;
        let list = row.data1.split('----');
        if (list){
          for (let i = 0; i < list.length; i++) {
            // console.log(list[i]);
            if (list[i] !== ""){
              json = JSON.parse(list[i]);
              if (json){
                for (let j = 0; j < json.length; j++) {
                  arr = json[j].data.split(';');
                  if (arr && arr.length >0){
                    this.userList = this.userList + "vs账号:" + json[j].vs +" 好友:"+arr.length+ "\n" + arr.join('\n')+"\n———————————————————\n";
                  }
                }
              }
            }
          }
        }

      }

    },
    friendCount(row){
      let count = 0;

      if (row.data1){

        let arr;
        let json;
        let list = row.data1.split('----');
        if (list){
          for (let i = 0; i < list.length; i++) {
            if (list[i] !== ""){
              json = JSON.parse(list[i]);
              if (json){
                for (let j = 0; j < json.length; j++) {
                  arr = json[j].data.split(';');
                  if (arr){
                    count = count+ arr.length;
                  }
                }
              }
            }
          }
        }

      }

      return count;
    },

    copyGroupList(){
      this.$copyText(this.userList.replace(/( |null)/g, '')).then(
          (e) => {
            this.$msgNot.success("复制成功");
          },
          (err) => {
            this.$msgNot.success("复制失败");
          }
      );
    },
    exportExcel() {
      let data = [
        ['序号','标记', '手机','备注','昵称']
      ];

      // console.log(this.userList);

      let arrLine = this.userList.trim().split('\n');
      let arr = []
      let arr2 = [];
      let count = 0;

      console.log(arrLine.length);

      for (let i = 0; i < arrLine.length; i++) {
        arr = arrLine[i].split('/');
        if(arr){
          count++
          for (let j = 0; j < arr.length; j++) {
            arr2 = [];
            arr2.push(count);         //序号
            arr2.push(this.groupName);//群名
            arr2.push(arr[1]);        //手机


            if (arr.length > 3){
              arr2.push(arr[2]);      //备注
              arr2.push(arr[3]);      //昵称
            }else if (arr.length > 2){
              arr2.push(arr[2]);
            }else {
              arr2.push("");
              arr2.push(arr[0]);
            }
          }
          data.push(arr2);
        }

      }


      // 创建工作簿
      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.SSF.format('yyyy-mm-dd', new Date());
      XLSX.utils.book_append_sheet(wb, ws, this.groupName);

      // 生成文件并保存
      const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, this.groupName+'_.xlsx');
    },


    refreshData(){

      this.pagParams.page  = 1;
      // this.pagParams.limit = 5;
      // this.pagParams.total = 5;
      this.pagParams.searchval = '';
      this.getData();
    },

    searchData(){
      this.pagParams.page = 1;
      this.getData();
    },

    async getData(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }
      const {data:res} = await this.$ajax.post("/api/tongji/getList",{'account':this.userName,'data':this.pagParams});
      if (res.code === 200){
        this.tableData = res.data;
        this.pagParams.total = res.total;
      }else {
        this.$msgNot.error('获取数据失败:'+res.msg);
      }

    },

    async delData(id){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      await this.$msgBox.confirm('确认删除此设备？','提示',{confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',})
          .then(async ()=>{
            const {data:res} = await this.$ajax.post("/api/tongji/deldata",{'account':this.userName,'id':id});
            if (res.code === 200){
              this.$msgNot.success('删除成功');
              await this.getData();
            }else {
              this.$msgNot.error('删除失败:'+res.msg);
            }

          }).catch(()=>{

          });




    },

    async clearData(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      await this.$msgBox.confirm('确认清空所有数据？','提示',{confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',})
          .then(async ()=>{
            const {data:res} = await this.$ajax.post("/api/tongji/clearData",{'account':this.userName});
            if (res.code === 200){
              this.$msgNot.success('清空成功');
              await this.getData();
            }else {
              this.$msgNot.err('清空失败:'+res.msg);
            }

          }).catch(()=>{

          });
    },
    async post_delFriends(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      await this.$msgBox.confirm('确认重置该设备好友列表？','提示',{confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',})
          .then(async ()=>{
            const {data:res} = await this.$ajax.post("/api/tongji/delFriends",{'account':this.userName,'machine':this.curDevice});
            if (res.code === 200){
              this.$msgNot.success('成功');
              await this.getData();
            }else {
              this.$msgNot.err('失败:'+res.msg);
            }

          }).catch(()=>{

          });
    },


    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pagParams.limit = val;
      this.getData();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pagParams.page = val;
      this.getData();
    },
    filterStatus(value, row) {
      return row.status === value;
    },
    handleChange(file) {
      this.file = file.raw;
    },
    tableRowClassName({row, rowIndex}) {
      return 'warning-row';
    },
    formatDate(row, column) {
      if(!row[column.property]) return '';
      let date = new Date(row[column.property] * 1000)
      const Y = date.getFullYear() + '-'
      const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-'
      const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
      const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
      const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    }
  }

}
</script>

<style>

.el-ta {
  /*background-color: #222D32;*/
  color: #000000;
  text-align: left;
  /*line-height: 150px;*/
  margin: 1px;
  padding: 1px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-table .warning-row {
  background: #f0f9eb;
}


</style>
